import * as React from 'react';
import { SVGProps } from 'react';

const IconSmileStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8Z" />
    <path d="M4.562 10.044a4 4 0 0 0 6.86.026l-1.36-.823a2.41 2.41 0 0 1-4.133-.016l-1.367.813ZM9 6h2v2H9V6ZM5 6h2v2H5V6Z" />
  </svg>
);
export default IconSmileStrokedSizeS;
